import { defineMessages } from 'react-intl';

export const addToBasketLayerMessages = defineMessages({
  criteoFallback: {
    id: 'rde.criteo-products.headline-fallback',
    defaultMessage: 'Gesponserte Artikel',
  },
  prudsysFallback: {
    id: 'addToBasket.layer.rde.prudsys.headline-fallback',
    defaultMessage: 'Andere Kunden kauften auch',
  },
  errorMessage: {
    id: 'addToBasketLayer.error.message',
    defaultMessage: 'Produkt konnte nicht geladen werden...',
  },
  errorButtonText: {
    id: 'addToBasketLayer.error.button.text',
    defaultMessage: 'Erneut versuchen',
  },
});
